import { createReactComponent } from './react-component-lib';
export const VmButton = createReactComponent('vm-button');
export const VmCheckbox = createReactComponent('vm-checkbox');
export const VmCheckboxGroup = createReactComponent('vm-checkbox-group');
export const VmFormField = createReactComponent('vm-form-field');
export const VmFormLabel = createReactComponent('vm-form-label');
export const VmGallery = createReactComponent('vm-gallery');
export const VmIcon = createReactComponent('vm-icon');
export const VmInput = createReactComponent('vm-input');
export const VmRadio = createReactComponent('vm-radio');
export const VmSearch = createReactComponent('vm-search');
export const VmSelect = createReactComponent('vm-select');
//# sourceMappingURL=index.js.map